/* eslint-disable import/no-anonymous-default-export */
const Data = ()=>(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.1723 2.75879C6.95 3.26562 5.85005 4.00787 4.92893 4.92898C3.11929 6.73865 2 9.23865 2 12C2 17.5229 6.47715 22 12 22C14.7614 22 17.2614 20.8807 19.0711 19.0711C19.9922 18.15 20.7344 17.05 21.2412 15.8277" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 12H22C22 6.47715 17.5229 2 12 2V12Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
    </svg>
)

export default {Data}